<template>
<div class="chapter">
<div class="inner_page">
<svg height="100%" version="1.1" viewbox="0 11 600 800" width="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<image height="800" transform="translate(0 0)" width="600" xlink:href="images/cover.jpg"></image>
</svg>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Sher_9781440522697_epub_c0_r1.vue?401e8f5a